import { Component, EventEmitter, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox, TimeApiService, UsedSgkz011aService } from 'cbc-shared-lib';
import { DateAdapter } from '@angular/material/core';
import { SgJpDateAdapter } from '../../../../../../sg-base/sg-base-shared/sg-jp-date-adapter';
import { Futai } from '../../../../../sg-kb-shared/models/futai.model';
import { Subject, Observable } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ResponseCommon,
  CodeConversionMstDto, CodeValueConversionMstDto,
  Sgkz011aResponseUserOrganizationDto,
  Sgkb986aResponse, Sgkb986aRequest,
  Szma301aResponse, Szma301aResponseGasCtrSearchResultDto, Szma301aCustomResponse,
  Szoa304aRequest, Szoa304aCustomRequest, Szoa304aResponse,
  Sgkb575aRequest, Sgkb575aResponse, Sgkb575aResCommonAceptSearchResultDto,
  Sgkb983aRequest, Sgkb983aResponse,
} from 'sg-api';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { CodeValueConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeValueConversionMst.service';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';
import { UsedSgkb941dSgkb575aService } from '../../services/used-sgkb941d-sgkb575a.service';
import { UsedSgkb986aService } from '../../../../../sg-kb-shared/services/used-sgkb986a.service';
import { UsedSzma301aService } from '../../../../../sg-kb-shared/services/used-szma301a.service';
import { UsedSgkb941dSzoa304aService } from '../../services/used-sgkb941d-szoa304a.service';
import { UsedSgkb941dSgkb983aService } from '../../services/used-sgkb941d-sgkb983a.service';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';

@Component({
  selector: 'app-sgkb941d-wt-contract-change',
  templateUrl: './sgkb941d-wt-contract-change.component.html',
  styleUrl: './sgkb941d-wt-contract-change.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [
    // 西部ガスオリジナル日付カレンダー使用に必要
    { provide: DateAdapter, useClass: SgJpDateAdapter },
  ],
})
export class Sgkb941dWtContractChangeComponent implements OnInit, OnDestroy {

  /** 画面タイトル設定通知イベント */
  @Output() titleChange = new EventEmitter<string>();
  /** メッセージ設定通知イベント */
  @Output() setMessageEvent = new EventEmitter<string>();

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;

  /** 契約共通情報FormGroup */
  ctrCommonInfo: UntypedFormGroup = this.fb.group({
    // 表示項目
    resaleBusAname: { value: '', disabled: false }, // ＷＴ卸利用事業者
    wtorishiserviceproviderAcceptancenumber: { value: '', disabled: false }, // ＷＴ卸利用事業者受付番号
    wtoroshiContractclassfyCode: [{ value: '', disabled: false }, Validators.required], // WT契約種別コード
    keiyakuHenkoYmd: [{ value: '', disabled: false }, Validators.required], // 適用年月日
    appliedAtTurnOn: { value: false, disabled: false }, // 開栓時適用
    wtoroshiGoodscode: { value: '', disabled: false }, // ＷＴ付帯契約コード
    highefficiencyWaterheater: { value: false, disabled: false }, // 高効率給湯器
    etcWaterheater: { value: false, disabled: false }, // その他給湯器
    kitchenequipment: { value: false, disabled: false }, // 厨房機器
    yukadanbo: { value: false, disabled: false }, // 床暖房
    bathroomheatingDryer: { value: false, disabled: false }, // 浴室暖房乾燥機
    etcHeatmachine: { value: false, disabled: false }, // その他暖房機
    airconditioning: { value: false, disabled: false }, // 空調機器
    cogenerationDevice: { value: false, disabled: false }, // コージェネ機器
    // HIDDEN    
    resaleBusCode: { value: '', disabled: false }, // ＷＴ卸利用事業者コード
    visitNo: { value: '', disabled: false }, // 内部お客さま番号
    logicDeviceNo: { value: '', disabled: false }, // 使用お客さま番号
    firstSrvctrNo: { value: '', disabled: false }, // 契約お客さま番号
    recptFixNo: { value: '', disabled: false }, // 請求お客さま番号
    extCnnctNo: { value: '', disabled: false }, // 外部接続番号
    claimMntdiv: { value: '', disabled: false }, // 請求月度区分
    rlystrFname: { value: '', disabled: false }, // 中継店担当者名
    agnissVisitNo: { value: '', disabled: false }, // 取次店発行お客さま番号
    prdCode: { value: '', disabled: false }, // プロダクトコード
    prdCtrDate: { value: '', disabled: false }, // サービス契約締結日付
    acsptPointCode: { value: '', disabled: false }, // 受入地点コード
    aceptNo: { value: '', disabled: false }, // 受付番号
    befWtoroshiContractclassfyCode: { value: '', disabled: false }, // 変更前WT契約種別コード
    befWtoroshiGoodscode: { value: '', disabled: false }, // 変更前ＷＴ付帯契約コード
  });

  // 画面間パラメータ（区分）
  mode?: string;
  // 画面間パラメータ（契約お客さま番号）
  firstSrvctrNo?: string;
  // 画面間パラメータ（受付番号）
  aceptNo?: string;
  // 画面間パラメータ（受付履歴番号）
  aceptRrkNo?: string;

  // ユーザ組織情報
  userOrganizationInfo: Sgkz011aResponseUserOrganizationDto = {
    sosikiId: '',
    sosikiName: '',
    comgrpcd: '',
    comCode: '',
    topSosikiId: '',
    areaCd: '',
    kyotenHyojiFlg: '',
    cmpnyName: '',
  };
  // ユーザーID
  usrId: string = "";

  // 受付ステータス
  aceptSts: string = "";

  // 更新通番号
  updateSrno: string = "";

  // 編集ボタン押下時に編集前の情報を補完
  beforeFv: any;

  /** 登録ボタン表示フラグ（初期値：非表示） */
  createDispFlg: boolean = false;
  /** キャンセルボタン表示フラグ（初期値：非表示） */
  cancelDispFlg: boolean = false;
  /** 閉じるボタン表示フラグ（初期値：非表示） */
  closeDispFlg: boolean = false;
  /** 編集ボタン表示フラグ（初期値：非表示） */
  editDispFlg: boolean = false;
  /** 取消ボタン表示フラグ（初期値：非表示） */
  deleteDispFlg: boolean = false;

  // API・サービス関連 ------------------------------------------------------------
  /** 契約検索・一覧照会結果 */
  sgkb986aResponse: Sgkb986aResponse;
  /** responseCommon(SGKB986) */
  sgkb986aResponseCommon: ResponseCommon;
  /** 契約情報検索結果 */
  contractor: any;

  /** 共通受付照会結果 */
  sgkb575aResponse: Sgkb575aResponse;
  /** responseCommon(SGKB575) */
  sgkb575aResponseCommon: ResponseCommon;
  /** 共通受付照会結果リスト */
  commonAceptSearchResultList: Array<Sgkb575aResCommonAceptSearchResultDto>;

  /** 受付エラー更新 */
  sgkb983aResponse: Sgkb983aResponse;

  /** 契約情報取得（ガス）結果 */
  szma301aResponse: Szma301aResponse;
  /** responseCommon(SZMA301A) */
  szma301aResponseCommon: ResponseCommon;
  /** レスポンスカスタマイズ(SZMA301A) */
  szma301aCustomResponse: Szma301aCustomResponse;
  /** 契約情報 検索結果格納DTO */
  gasCtrSearchResultDto: Szma301aResponseGasCtrSearchResultDto;

  // ガス契約情報変更受付登録
  szoa304aResponse: Szoa304aResponse;

  // SZMA301A API送信を行うために設定
  srvCtrNo: string;

  // コード値変換API送信を行うために設定
  branchNo: string = "";
  codeValList: string[] = [];
  codeValConvMap: Map<string, Array<CodeValueConversionMstDto>>;
  //変換識別種別コード（ＷＴ卸利用事業者コード→ＷＴ契約種別関連コードＩＤ枝番）
  discrmClsCodesgkb031: string = "SGKB031";

  // コード変換API用
  constProductCodeKey: string = "S00078";
  constGoodsCodeKey: string = "S00079";
  productCodeKey: string = "";
  goodsCodeKey: string = "";
  codeList: string[] = [];
  codeConvMap: Map<string, Array<CodeConversionMstDto>>;

  // SelectBox用（料金プラン・付帯商品）
  productList: SelectBox[] = [];
  futaiList: SelectBox[] = [];

  // 編集ボタン表示用受付ステータスリスト
  editBtnCtlAceptStsList: Array<string> = [SgkbConstains.CODE.ACEPT_STS.KAITU_ENT_REQ, SgkbConstains.CODE.ACEPT_STS.NTRY_COMPLETE];
  // 取消ボタン表示用受付ステータスリスト
  deleteBtnCtlAceptStsList: Array<string> = [SgkbConstains.CODE.ACEPT_STS.ENTRY_ERROR, SgkbConstains.CODE.ACEPT_STS.KAITU_ENT_REQ,
  SgkbConstains.CODE.ACEPT_STS.KAITU_ENT_ERR, SgkbConstains.CODE.ACEPT_STS.NTRY_COMPLETE, SgkbConstains.CODE.ACEPT_STS.MATER_ERROR];

  // 取消時実行API判定用受付ステータス
  aceptStsErrList: Array<string> = [SgkbConstains.CODE.ACEPT_STS.ENTRY_ERROR, SgkbConstains.CODE.ACEPT_STS.KAITU_ENT_ERR, SgkbConstains.CODE.ACEPT_STS.MATER_ERROR];

  // 区分判定用
  // 登録
  constModeCreate: string = 'create';
  // 照会
  constModeRead: string = 'read';
  // 編集
  constModeEdit: string = 'edit';

  // 画面項目
  // 表示項目
  // ＷＴ卸利用事業者
  dipsResaleBusAname: string;
  // ＷＴ卸利用事業者受付番号
  dispWtorishiserviceproviderAcceptancenumber: string;
  // WT契約種別コード
  dispWtoroshiContractclassfyCode: string;

  // 適用年月日
  dispKeiyakuHenkoYmd: Date;
  // 開栓時適用
  dispAppliedAtTurnOn: boolean;
  // ＷＴ付帯契約コード
  dispWtoroshiGoodscode: string;
  // 高効率給湯器
  dispHighefficiencyWaterheater: boolean;
  // その他給湯器
  dispEtcWaterheater: boolean;
  // 厨房機器
  dispKitchenequipment: boolean;
  // 床暖房
  dispYukadanbo: boolean;
  // 浴室暖房乾燥機
  dispBathroomheatingDryer: boolean;
  // その他暖房機
  dispEtcHeatmachine: boolean;
  // 空調機器
  dispAirconditioning: boolean;
  // コージェネ機器
  dispCogenerationDevice: boolean;

  // 非表示項目 
  // ＷＴ卸利用事業者コード
  dispResaleBusCode: string;
  // 内部お客さま番号
  dispVisitNo: string;
  // 使用お客さま番号
  dispLogicDeviceNo: string;
  // 契約お客さま番号
  dispFirstSrvctrNo: string;
  // 請求お客さま番号
  dispRecptFixNo: string;
  // 外部接続番号
  dispExtCnnctNo: string;
  // 請求月度区分
  dispClaimMntdiv: string;
  // 中継店担当者名
  dispRlystrFname: string;
  // 取次店発行お客さま番号
  dispAgnissVisitNo: string;
  // 受入地点コード
  dispAcsptPointCode: string;
  // 受付番号
  dispAceptNO: string;
  // 変更前WT契約種別コード
  dispBefWtoroshiContractclassfyCode: string;
  // 変更前ＷＴ付帯契約コード
  dispBefWtoroshiGoodscode: string;

  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @memberof Sgkb941dWtContractChangeComponent
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private timeApiService: TimeApiService,
    private completeDataService: CompleteDataService,
    private codeConversionMstService: CodeConversionMstService,
    private codeValueConversionMstService: CodeValueConversionMstService,
    private usedSgkz011aService: UsedSgkz011aService,
    private usedSgkb575aService: UsedSgkb941dSgkb575aService,
    private usedSgkb986aService: UsedSgkb986aService,
    private usedSzma301aService: UsedSzma301aService,
    private usedSgkb941dSzoa304aService: UsedSgkb941dSzoa304aService,
    private usedSgkb941dSgkb983aService: UsedSgkb941dSgkb983aService
  ) {

  }

  /**
   * onInit
   * @memberof Sgkb941dWtContractChangeComponent
   */
  ngOnInit(): void {
    // 業務日付・ユーザー情報等を更新
    this.timeApiService.updateBussinessDate();  // 業務日付取得
    this.usedSgkz011aService.updateUserInfo();  // ユーザ情報取得
    this.usedSgkz011aService.userOrganizationInfo.pipe(takeUntil(this.onDestroy$)).subscribe(userOrganizationInfo => {
      this.userOrganizationInfo = userOrganizationInfo;
    });
    this.usedSgkz011aService.userId.pipe(takeUntil(this.onDestroy$)).subscribe(userId => {
      this.usrId = userId;
    });

    this.parentForm = this.parent.form;

    // 画面間パラメータ受け取り（区分）
    this.mode = this.route.snapshot.paramMap.get('mode');
    // 区分が新規登録の場合
    if (this.mode === this.constModeCreate) {
      // 画面間パラメータ受け取り（契約お客さま番号）
      this.firstSrvctrNo = this.route.snapshot.paramMap.get('firstSrvctrNo');
      this.dispFirstSrvctrNo = this.route.snapshot.paramMap.get('firstSrvctrNo');
      // 区分が照会の場合
    } else if (this.mode === this.constModeRead) {
      // 画面間パラメータ受け取り（受付番号）
      this.aceptNo = this.route.snapshot.paramMap.get('aceptNo');
      // 画面間パラメータ受け取り（受付履歴番号）
      this.aceptRrkNo = this.route.snapshot.paramMap.get('aceptRrkno');
    }

    // 各サービス呼び出し
    this.getInitialData();
  }

  /**
   * 画面初期化情報取得
   * @memberof Sgkb941dWtContractChangeComponent
   */
  getInitialData(): void {
    // 区分が照会の場合
    if (this.mode === this.constModeRead) {
      // 表示項目を非活性にする
      this.ctrCommonInfo.disable();

      // 閉じるボタンを表示する
      this.closeDispFlg = true;

      //「SGKB575A_共通受付照会」呼び出し
      const sgkb575aRequest: Sgkb575aRequest = {
        requestCommon: {
          businessDate: null,
          startLine: 0,
          getNumber: 0,
          dryRun: false,
          businessReqId: null,
          funcLinkId: null,
          requestCustomize: null,
        },
        aceptSearchInfo: {
          aceptNo: this.aceptNo,
          doknjgyshAppAcceptancenumber: null,
          acceptancerirekiHyojiFlg: false
        }
      }
      this.usedSgkb575aService.searchContractor(sgkb575aRequest)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(resSgkb575a => {
          if (resSgkb575a != null) {
            this.sgkb575aResponse = resSgkb575a;
            this.sgkb575aResponseCommon = resSgkb575a.responseCommon;
            this.commonAceptSearchResultList = resSgkb575a.commonAceptSearchResultList;

            // 画面項目値設定
            if (this.commonAceptSearchResultList.length > 0) {
              let sgkb575aResCommonAceptSearchResultDto = this.commonAceptSearchResultList[0];
              this.dipsResaleBusAname = sgkb575aResCommonAceptSearchResultDto.gasConInfo.resaleBusAname;
              this.dispWtorishiserviceproviderAcceptancenumber = sgkb575aResCommonAceptSearchResultDto.ctrCommonInfo.rlysrnNo;
              this.dispKeiyakuHenkoYmd = this.timeApiService.convertStringToDate(sgkb575aResCommonAceptSearchResultDto.wtOroshiInfo.wtCtrchgScddt);
              this.dispAppliedAtTurnOn = sgkb575aResCommonAceptSearchResultDto.wtOroshiInfo.wtApplicationdateDivcd == "1" ? true : false;
              this.dispHighefficiencyWaterheater = sgkb575aResCommonAceptSearchResultDto.deviceInfo.highefficiencyWaterheater == "1" ? true : false;
              this.dispEtcWaterheater = sgkb575aResCommonAceptSearchResultDto.deviceInfo.etcWaterheater == "1" ? true : false;
              this.dispKitchenequipment = sgkb575aResCommonAceptSearchResultDto.deviceInfo.kitchenequipment == "1" ? true : false;
              this.dispYukadanbo = sgkb575aResCommonAceptSearchResultDto.deviceInfo.yukadanbo == "1" ? true : false;
              this.dispBathroomheatingDryer = sgkb575aResCommonAceptSearchResultDto.deviceInfo.bathroomheatingDryer == "1" ? true : false;
              this.dispEtcHeatmachine = sgkb575aResCommonAceptSearchResultDto.deviceInfo.etcHeatmachine == "1" ? true : false;
              this.dispAirconditioning = sgkb575aResCommonAceptSearchResultDto.deviceInfo.airconditioning == "1" ? true : false;
              this.dispCogenerationDevice = sgkb575aResCommonAceptSearchResultDto.deviceInfo.cogenerationDevice == "1" ? true : false;
              this.dispResaleBusCode = sgkb575aResCommonAceptSearchResultDto.gasConInfo.resaleBusCode;
              this.dispVisitNo = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.visitNo;
              this.dispLogicDeviceNo = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.logicDeviceNo;
              this.dispFirstSrvctrNo = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.firstSrvctrNo;
              this.dispRecptFixNo = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.recptFixNo;
              this.dispExtCnnctNo = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.extCnnctNo;
              this.dispClaimMntdiv = sgkb575aResCommonAceptSearchResultDto.ctrCommonInfo.claimMntdiv;
              this.dispRlystrFname = sgkb575aResCommonAceptSearchResultDto.ctrCommonInfo.rlystrFname;
              this.dispAgnissVisitNo = sgkb575aResCommonAceptSearchResultDto.ctrCommonInfo.agnissVisitNo;
              this.dispWtoroshiContractclassfyCode = sgkb575aResCommonAceptSearchResultDto.wtOroshiInfo.wtContractclassfyCode;
              if (sgkb575aResCommonAceptSearchResultDto.ftiGoodsInfo != null && sgkb575aResCommonAceptSearchResultDto.ftiGoodsInfo.ftiGoodsList != null) {
                this.dispWtoroshiGoodscode = sgkb575aResCommonAceptSearchResultDto.ftiGoodsInfo.ftiGoodsList[0].wtFutaicontractcode;
              }

              // 受付番号と受付履歴番号の一致判定
              if (this.decisionParam(sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.aceptNo,
                sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.aceptRrkno)) {

                // 「SGKB986A_契約検索・一覧照会」呼び出し
                this.searchContractorSgkb986a();
                // コード値変換（転売先事業者が選択可能な料金プラン・付帯を取得するための枝番取得）
                this.getCodeValueConversionMst(sgkb575aResCommonAceptSearchResultDto.gasConInfo.resaleBusCode);

                // 受付ステータス
                this.aceptSts = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.aceptSts;
                // 更新通番号
                this.updateSrno = sgkb575aResCommonAceptSearchResultDto.aceptCommonInfo.updateSrno;

              } else {
                // エラーメッセージ出力
                this.setMessageEvent.emit('対象の受付が他者によって更新されています');
              }
            }
          }
        }, error => {
        });
      // 区分が新規登録の場合
    } else if (this.mode === this.constModeCreate) {

      // 「SGKB986A_契約検索・一覧照会」呼び出し
      this.searchContractorSgkb986a();
    }
  }

  /**
   * 共通受付照会で取得した受付番号、受付履歴番号が画面間パラメータの受付番号、受付履歴番号と一致するか
   */
  decisionParam(sgkb575aResAceptNo: string, sgkb575aResAceptRrkNo: string): boolean {
    // 受付番号判定
    if (sgkb575aResAceptNo !== this.aceptNo) {
      // 一致しなかったらfalse
      return false;
    }
    // 受付履歴番号判定
    if (sgkb575aResAceptRrkNo !== this.aceptRrkNo) {
      // 一致しなかったらfalse
      return false;
    }
    // 受付番号、受付履歴番号共に一致したら
    return true;
  }

  /**
   * 「SGKB986A_契約検索・一覧照会」呼び出し
   * @memberof Sgkb941dWtContractChangeComponent
   */
  searchContractorSgkb986a(): void {

    const sgkb986aRequest: Sgkb986aRequest = {
      requestCommon: {
        businessDate: null,
        startLine: 0,
        getNumber: 0,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      ctrSearchInfo: {
        firstSrvctrNo: this.dispFirstSrvctrNo,
        ctrStatus: SgkbConstains.CODE.CNTRCT_STATUS.ACTIVEONLY,  // 契約状況：'1'(現在契約中のみ)
        contractlistSortPatterncode: SgkbConstains.CODE.CNTRCT_LIST_SORT_PTRN_CD.MYPAGE,  //契約一覧ソートパターンコード:'2'(マイページ)
      }
    }
    this.usedSgkb986aService.searchContractor(sgkb986aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(resSgkb986a => {
        if (resSgkb986a != null) {

          this.sgkb986aResponse = resSgkb986a;
          this.sgkb986aResponseCommon = resSgkb986a.responseCommon;
          this.contractor = resSgkb986a.ctrSearchresultList;

          // 区分が新規登録の場合
          if (this.mode === this.constModeCreate) {
            // 契約検索結果リスト(0)．契約検索結果．契約情報．請求お客さま番号をHidden項目の請求お客さま番号に設定
            this.ctrCommonInfo.controls['recptFixNo'].setValue(this.contractor[0].description.recptFixNo);
            // 区分が照会の場合
          }
          // 契約検索結果リスト(0)．契約検索結果．契約情報．サービス契約番号を内部取得
          this.srvCtrNo = this.contractor[0].description.srvCtrNo;

          // 「SZMA301A_契約情報取得（ガス）」呼び出し
          this.searchContractorSzma301a();
        }
      }, error => {
      });
  }


  /**
   * 「SZMA301A_契約情報取得（ガス）」呼び出し
   * @memberof Sgkb941dWtContractChangeComponent
   */
  searchContractorSzma301a(): void {
    this.usedSzma301aService.searchContractor(this.srvCtrNo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(resSzma301a => {
        if (resSzma301a != null) {
          // 画面項目値設定
          this.szma301aCustomResponse = <Szma301aCustomResponse>resSzma301a.responseCommon.responseCustomize;
          // 区分が新規登録の場合
          if (this.mode === this.constModeCreate) {
            this.dipsResaleBusAname = resSzma301a.gasCtrSearchResultDto.gasCtrMstInfo.resaleBusAname;
            this.dispWtoroshiContractclassfyCode = this.szma301aCustomResponse.ctrCommonInfo.wtoroshiContractclassfyCode;
            this.dispHighefficiencyWaterheater = this.szma301aCustomResponse.deviceInfo.highefficiencyWaterheater == "1" ? true : false;
            this.dispEtcWaterheater = this.szma301aCustomResponse.deviceInfo.etcWaterheater == "1" ? true : false;
            this.dispKitchenequipment = this.szma301aCustomResponse.deviceInfo.kitchenequipment == "1" ? true : false;
            this.dispYukadanbo = this.szma301aCustomResponse.deviceInfo.yukadanbo == "1" ? true : false;
            this.dispBathroomheatingDryer = this.szma301aCustomResponse.deviceInfo.bathroomheatingDryer == "1" ? true : false;
            this.dispEtcHeatmachine = this.szma301aCustomResponse.deviceInfo.etcHeatmachine == "1" ? true : false;
            this.dispAirconditioning = this.szma301aCustomResponse.deviceInfo.airconditioning == "1" ? true : false;
            this.dispCogenerationDevice = this.szma301aCustomResponse.deviceInfo.cogenerationDevice == "1" ? true : false;
            this.dispResaleBusCode = resSzma301a.gasCtrSearchResultDto.gasCtrMstInfo.resaleBusCode;
            this.dispVisitNo = resSzma301a.gasCtrSearchResultDto.ctrperMstInfo.visitNo;
            this.dispLogicDeviceNo = resSzma301a.gasCtrSearchResultDto.empposUserMstInfo.empposUserMstList[0].empposMstInfo.logicDeviceNo;
            this.dispFirstSrvctrNo = resSzma301a.gasCtrSearchResultDto.ctrCommonMstInfo.firstSrvctrNo;
            this.dispExtCnnctNo = resSzma301a.gasCtrSearchResultDto.empposUserMstInfo.empposUserMstList[0].empposMstInfo.extCnnctNo;
            this.dispClaimMntdiv = resSzma301a.gasCtrSearchResultDto.ctrCommonMstInfo.claimMnttmDiv;
            this.dispRlystrFname = resSzma301a.gasCtrSearchResultDto.ctrCommonMstInfo.rlystrFname;
            this.dispAgnissVisitNo = resSzma301a.gasCtrSearchResultDto.ctrCommonMstInfo.agnissVisitNo;
            this.dispAcsptPointCode = resSzma301a.gasCtrSearchResultDto.gasCtrMstInfo.acsptPointCode;
            this.dispBefWtoroshiContractclassfyCode = this.szma301aCustomResponse.ctrCommonInfo.wtoroshiContractclassfyCode;
            if (this.szma301aCustomResponse.ftiGoodsInfo != null && this.szma301aCustomResponse.ftiGoodsInfo.ftiGoodsList != null) {
              this.dispWtoroshiGoodscode = this.szma301aCustomResponse.ftiGoodsInfo.ftiGoodsList[0].wtoroshiGoodscode;
              this.dispBefWtoroshiGoodscode = this.szma301aCustomResponse.ftiGoodsInfo.ftiGoodsList[0].wtoroshiGoodscode;
            }
            // コード値変換（転売先事業者が選択可能な料金プラン・付帯を取得するための枝番取得）
            this.getCodeValueConversionMst(resSzma301a.gasCtrSearchResultDto.gasCtrMstInfo.resaleBusCode);

            // 画面表示項目設定
            this.setDispItemValue();

            // ボタン表示制御
            this.btnDispCtl(this.constModeCreate);
            // 区分が照会の場合
          } else if (this.mode === this.constModeRead) {
            this.dispBefWtoroshiContractclassfyCode = this.szma301aCustomResponse.ctrCommonInfo.wtoroshiContractclassfyCode;
            this.dispAcsptPointCode = resSzma301a.gasCtrSearchResultDto.gasCtrMstInfo.acsptPointCode;
            if (this.szma301aCustomResponse.ftiGoodsInfo != null && this.szma301aCustomResponse.ftiGoodsInfo.ftiGoodsList != null) {
              this.dispBefWtoroshiGoodscode = this.szma301aCustomResponse.ftiGoodsInfo.ftiGoodsList[0].wtoroshiGoodscode;
            }

            // 画面表示項目設定
            this.setDispItemValue();

            // ボタン表示制御 
            this.btnDispCtl(this.constModeRead);

          }
        }
      }, error => {
      });
  }

  /**
    * コード値変換呼び出し（転売先事業者が選択可能な料金プラン・付帯を取得するための枝番取得）
    * @memberof Sgkb941dWtContractChangeComponent
    */
  getCodeValueConversionMst(resaleBusCode: string): void {
    // 転売先事業者が選択可能な契約種別・付帯のパターン（枝番）を取得
    this.codeValueConversionMstService.getCodeValueConversionMst([this.discrmClsCodesgkb031])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(resCodeVal => {
        if (resCodeVal != null) {
          this.codeValConvMap = new Map(resCodeVal)
          let codeValueConversionMstDtoList = this.codeValConvMap.get(this.discrmClsCodesgkb031);
          // コード値変換マスタDtoリストから転売先事業者に一致するコード値変換マスタDtoを取得
          let codeValueDto = codeValueConversionMstDtoList.find((codeValue) =>
            codeValue.cnversOriginCode1 === resaleBusCode);

          // 枝番を取得
          this.branchNo = codeValueDto.cnversAfterCode1;

          // コード変換取得（選択可能な料金プラン・付帯取得とSelectBoxを設定）
          this.getCodeConversionMst();
        }
      }, error => {
      });
  }

  /**
   * コード変換呼び出し（選択可能な料金プラン・付帯取得とSelectBoxを設定）
   * @memberof Sgkb941dWtContractChangeComponent
   */
  getCodeConversionMst(): void {
    // 転売先事業者が選択可能な契約種別・付帯を取得
    this.productCodeKey = this.constProductCodeKey + this.branchNo;
    this.goodsCodeKey = this.constGoodsCodeKey + this.branchNo;
    this.codeList = [this.productCodeKey, this.goodsCodeKey];
    this.codeConversionMstService.getCodeConversionMst(this.codeList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(resCode => {
        if (resCode != null) {
          this.codeConvMap = new Map(resCode);

          // SelectBox生成
          this.productList = this.makeSelectBoxData(this.productCodeKey);
          this.futaiList = this.makeSelectBoxData(this.goodsCodeKey);
        }
      }, error => {
      });
  }

  /**
   * 画面項目設定
   * @memberof Sgkb941dWtContractChangeComponent
   */
  setDispItemValue() {
    this.ctrCommonInfo.controls['resaleBusAname'].setValue(this.dipsResaleBusAname);
    this.ctrCommonInfo.controls['wtoroshiContractclassfyCode'].setValue(this.dispWtoroshiContractclassfyCode);
    this.ctrCommonInfo.controls['appliedAtTurnOn'].setValue(this.dispAppliedAtTurnOn);
    this.ctrCommonInfo.controls['wtoroshiGoodscode'].setValue(this.dispWtoroshiGoodscode);
    this.ctrCommonInfo.controls['highefficiencyWaterheater'].setValue(this.dispHighefficiencyWaterheater);
    this.ctrCommonInfo.controls['etcWaterheater'].setValue(this.dispEtcWaterheater);
    this.ctrCommonInfo.controls['kitchenequipment'].setValue(this.dispKitchenequipment);
    this.ctrCommonInfo.controls['yukadanbo'].setValue(this.dispYukadanbo);
    this.ctrCommonInfo.controls['bathroomheatingDryer'].setValue(this.dispBathroomheatingDryer);
    this.ctrCommonInfo.controls['etcHeatmachine'].setValue(this.dispEtcHeatmachine);
    this.ctrCommonInfo.controls['airconditioning'].setValue(this.dispAirconditioning);
    this.ctrCommonInfo.controls['cogenerationDevice'].setValue(this.dispCogenerationDevice);
    this.ctrCommonInfo.controls['resaleBusCode'].setValue(this.dispResaleBusCode);
    this.ctrCommonInfo.controls['visitNo'].setValue(this.dispVisitNo);
    this.ctrCommonInfo.controls['logicDeviceNo'].setValue(this.dispLogicDeviceNo);
    this.ctrCommonInfo.controls['firstSrvctrNo'].setValue(this.dispFirstSrvctrNo);
    this.ctrCommonInfo.controls['extCnnctNo'].setValue(this.dispExtCnnctNo);
    this.ctrCommonInfo.controls['claimMntdiv'].setValue(this.dispClaimMntdiv);
    this.ctrCommonInfo.controls['rlystrFname'].setValue(this.dispRlystrFname);
    this.ctrCommonInfo.controls['agnissVisitNo'].setValue(this.dispAgnissVisitNo);
    this.ctrCommonInfo.controls['acsptPointCode'].setValue(this.dispAcsptPointCode);
    this.ctrCommonInfo.controls['befWtoroshiContractclassfyCode'].setValue(this.dispWtoroshiContractclassfyCode);
    this.ctrCommonInfo.controls['befWtoroshiGoodscode'].setValue(this.dispWtoroshiGoodscode);
    if (this.mode === this.constModeRead) {
      // ＷＴ卸利用事業者受付番号
      this.ctrCommonInfo.controls['wtorishiserviceproviderAcceptancenumber'].setValue(this.dispWtorishiserviceproviderAcceptancenumber);
      // 適用年月日
      this.ctrCommonInfo.controls['keiyakuHenkoYmd'].setValue(this.dispKeiyakuHenkoYmd);
      // 請求お客さま番号
      this.ctrCommonInfo.controls['recptFixNo'].setValue(this.dispRecptFixNo);
    }
  }

  /** 
  * IDからSelectBoxを作成
  * @memberof Sgkb941dWtContractChangeComponent
  */
  makeSelectBoxData(codeId: string): SelectBox[] {
    let selectList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];

    if (this.codeConvMap.has(codeId)) {
      codeList = this.codeConvMap.get(codeId);
      codeList.sort((a, b) => {
        return a.hyojiRowTurn.localeCompare(b.hyojiRowTurn);
      });
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          selectList.push(select);
        })
      }
    }
    return selectList;
  }

  /**
 * ボタン表示制御
 * @memberof Sgkb941dWtContractChangeComponent
 */
  btnDispCtl(mode: string): void {
    // 新規登録
    if (mode === this.constModeCreate) {
      // 登録ボタン 表示
      this.createDispFlg = true;
      // キャンセルボタン 非表示
      this.cancelDispFlg = false;
      // 閉じるボタン 表示
      this.closeDispFlg = true;
      // 編集ボタン 非表示
      this.editDispFlg = false;
      // 取消ボタン 非表示
      this.deleteDispFlg = false;
      // 照会
    } else if (mode === this.constModeRead) {
      // 登録ボタン 非表示
      this.createDispFlg = false;
      // キャンセルボタン 非表示
      this.cancelDispFlg = false;
      // 閉じるボタン 表示
      this.closeDispFlg = true;

      // 受付ステータスによる編集ボタン表示制御
      if (this.editBtnCtlAceptStsList.includes(this.aceptSts)) {
        // 編集ボタン 表示
        this.editDispFlg = true;
      } else {
        // 編集ボタン 非表示
        this.editDispFlg = false;
      }

      // 受付ステータスによる取消ボタン表示制御
      if (this.deleteBtnCtlAceptStsList.includes(this.aceptSts)) {
        // 取消ボタン 表示
        this.deleteDispFlg = true;
      } else {
        // 取消ボタン 非表示
        this.deleteDispFlg = false;
      }

      // 編集
    } else if (mode === this.constModeEdit) {
      // 登録ボタン 表示
      this.createDispFlg = true;
      // キャンセルボタン 表示
      this.cancelDispFlg = true;
      // 閉じるボタン 非表示
      this.closeDispFlg = false;
      // 編集ボタン 非表示
      this.editDispFlg = false;
      // 取消ボタン 非表示
      this.deleteDispFlg = false;
    }
  }

  /**
   * onDestroy
   * @memberof Sgkb941dWtContractChangeComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    if (this.parent.form != null) {
      this.parentForm.clearValidators();
      this.parentForm.updateValueAndValidity();
      this.parent.form.removeControl('ctrCommonInfo');  // 親画面のFormGroupからコントロールを削除
    }
    this.ctrCommonInfo.clearValidators();
    this.ctrCommonInfo.updateValueAndValidity();
  }

  /**
   * 登録ボタン押下時イベント
   * @memberof Sgkb941dWtContractChangeComponent
   */
  onSubmit(): void {
    // ガス契約情報変更受付登録

    // 設定値算出
    const fv = this.ctrCommonInfo.getRawValue();

    // リクエスト定義
    let szoa304aRequest: Szoa304aRequest;
    let szoa304aCustomReq: Szoa304aCustomRequest;

    // WT契約変更区分
    let setWtCtrchgDivcd = this.decisionWtCtrchgDiv(fv);

    // 区分が新規登録の場合
    if (this.mode == this.constModeCreate) {
      // SZOA304Aリクエスト準備
      szoa304aCustomReq = {
        srnMethod: SgkbConstains.CODE.SRN_METHOD.OTHER, // 申込方法：'9'その他
        tksLinkEonflg: SgkbConstains.CODE.TAKUSOU_RENKEI_UMU_FLG.TRUE, // 託送連係有無フラグ：'1'(連係する)
        wtOrishiserviceproviderCode: fv.resaleBusCode, // ＷＴ卸利用事業者コード：非表示.ＷＴ卸利用事業者コード
        wtContractclassfyCode: fv.wtoroshiContractclassfyCode, // ＷＴ契約種別コード：契約共通情報.WT契約種別コード
        wtFutaicontractList: fv.wtoroshiGoodscode ? [ // ＷＴ付帯契約リスト（ＷＴ付帯契約コードが設定されている場合のみ設定する）
          {
            wtFutaicontractcode: fv.wtoroshiGoodscode, // ＷＴ付帯契約コード：契約共通情報.ＷＴ付帯契約コード
          }
        ] : null,
        wtCtrchgDivcd: <string>setWtCtrchgDivcd, // ＷＴ契約変更区分コード
        wtApplicationdateDivcd: fv.appliedAtTurnOn ? SgkbConstains.CODE.WT_ADOPT_DAY_DIV_CD.RETRO_CHANGE : SgkbConstains.CODE.WT_ADOPT_DAY_DIV_CD.NEXT_DAY, //  (開栓時適用にチェックがある場合'1'(遡及変更（開栓日orスイッチ日）)、それ以外'0'(次回検針日の翌日))
        wtCtrchgScddt: this.getFormattedDateYMD(fv.keiyakuHenkoYmd), // ＷＴ契約変更予定日付：適用年月日
        highefficiencyWaterheater: fv.highefficiencyWaterheater ? "1" : "0",  // 高効率給湯器：契約共通情報.高効率給湯器
        etcWaterheater: fv.etcWaterheater ? "1" : "0",  // その他給湯器：契約共通情報.その他給湯器
        kitchenequipment: fv.kitchenequipment ? "1" : "0",  // 厨房機器：契約共通情報.厨房機器
        yukadanbo: fv.yukadanbo ? "1" : "0",  // 床暖房：契約共通情報.床暖房
        bathroomheatingDryer: fv.bathroomheatingDryer ? "1" : "0",  // 浴室暖房乾燥機：契約共通情報.浴室暖房乾燥機
        etcHeatmachine: fv.etcHeatmachine ? "1" : "0",  // その他暖房機：契約共通情報.その他暖房機
        airconditioning: fv.airconditioning ? "1" : "0",  // 空調機器：契約共通情報.空調機器
        cogenerationDevice: fv.cogenerationDevice ? "1" : "0",  // コージェネ機器：契約共通情報.コージェネ機器

      };
      szoa304aRequest = {
        requestCommon: { // 共通情報
          businessDate: null,  // 業務日付
          startLine: 0,  // 取得開始行
          getNumber: 0,  // 取得件数
          dryRun: false,  // ドライラン
          businessReqId: null,  // 業務リクエストID
          funcLinkId: null,  // 機能連携ID
          requestCustomize: szoa304aCustomReq,
        },
        aceptInfo: { // 受付情報
          aceptNo: null,
          aceptRrkno: null,
          updateSrno: null,
          updateDiv: SgkbConstains.CODE.UPDATE_DIV.REGIST, // 更新区分：'1'(登録)
          visitNo: fv.visitNo,  // 内部お客さま番号：非表示.内部お客さま番号
          logicDeviceNo: fv.logicDeviceNo,  // 使用お客さま番号：非表示.使用お客さま番号
          firstSrvctrNo: fv.firstSrvctrNo,  // 契約お客さま番号：非表示.契約お客さま番号  
          recptFixNo: fv.recptFixNo,  // 請求お客さま番号：非表示.請求お客さま番号
          simltnAceptNo: null,
          aceptClsfy: SgkbConstains.CODE.ACEPT_CLY_CD.GAS_CNTRCT_CHANGE,  // 受付種別コード：'040201'(ガス契約変更)
          aceptDate: this.timeApiService.getNowDateString(),  // 受付日付：業務日付
          aceptHms: this.timeApiService.getNowTimeString(),  // 受付時刻：システム時刻
          aceptSosikiCode: this.userOrganizationInfo.sosikiId,  // 受付担当組織番号：ログイン情報.組織番号
          aceptStaffNo: this.usrId,  // 受付担当社員番号：ログイン情報.社員番号
          cnscncYhiflg: SgkbConstains.CODE.TAKUSOU_CNTACT_TRANS_FLG.TRANS_NO_CONTACT,  // 託送連絡要否フラグ：'0'(託送連絡不要)
          extCnnctNo: fv.extCnnctNo,  // 外部接続番号：非表示.外部接続番号
        },
        ctrCommonInfo: { // 契約共通情報
          ctrendDateDiv: SgkbConstains.CODE.CNTRCT_ENDDAY_DIV.NO_TARGET,  // 契約終了日区分：'1'(指定なし)
          ctrchgDateDiv: fv.appliedAtTurnOn ? SgkbConstains.CODE.CNTRCT_STARTDAY_DIV.CNTRCT_START_DATE
            : SgkbConstains.CODE.CNTRCT_STARTDAY_DIV.REGLR_READMON_SPEC,  // 契約変更日区分：開栓時適用にチェックがある場合'3'(契約開始日指定)、それ以外'1'(定例検針月指定)
          ctrchgYm: fv.appliedAtTurnOn ? "" : this.getFormattedDateYM(fv.keiyakuHenkoYmd),  // 契約変更年月：契約共通情報.適用年月日（開栓時適用にチェックがない場合項目名の年月のみ設定）
          ctrChgDate: fv.appliedAtTurnOn ? this.getFormattedDateYMD(fv.keiyakuHenkoYmd) : "",  // 契約変更日付：契約共通情報.適用年月日（開栓時適用にチェックがある場合項目名）
          claimMntdiv: fv.claimMntdiv,  // 請求月度区分：非表示.請求月度区分
          rlysrnNo: fv.wtorishiserviceproviderAcceptancenumber,  // 中継店申込番号：契約共通情報.ＷＴ卸利用事業者受付番号
          rlystrFname: fv.rlystrFname,  // 中継店担当者名：非表示.中継店担当者名
          agnissVisitNo: fv.agnissVisitNo,  // 取次店発行お客さま番号：非表示.取次店発行お客さま番号
          prdCode: null,  // プロダクトコード：非表示.プロダクトコード
        },
        ftiGoodsInfo: null, // 付帯商品契約情報
        ctrTankaInfo: null, // 契約単価情報 
        gasConInfo: { // ガス契約情報
          acsptPointCode: this.dispAcsptPointCode,  // 受入地点コード
          cnsgmtCtrNo: "00000000000000000",  // 託送契約番号：「00000000000000000」（17桁）固定
          chargeCategCode: null,  // 託送供給契約約款区分コード：非表示.託送供給契約約款区分コード
        },
        gasConvalInfo: null, // ガス契約値情報
      }
      this.usedSgkb941dSzoa304aService.registReception(szoa304aRequest)
        .subscribe(response => {
          if (response) {
            this.szoa304aResponse = response;

            // 受付情報．受付番号をHidden項目の受付番号に設定
            this.ctrCommonInfo.controls['aceptNo'].setValue(response.aceptInfo.aceptNo);
            // 登録完了画面遷移
            this.completeDataService.completeData = {
              title: 'WT契約変更登録完了',       // 画面タイトルを設定
              message: 'WT契約変更を登録しました', // 画面に表示するメッセージを設定
              next: '',
              koumokuList: [
                { label: "受付番号", val: this.ctrCommonInfo.getRawValue().aceptNo }
              ], // 画面に表示する情報
              queryParams: {
                "aceptNo": this.ctrCommonInfo.getRawValue().aceptNo,
              },
            }
            // 登録完了画面遷移
            this.router.navigate(['/sgkz003d']);
          }
        }, error => {
        });
      // 区分が照会の場合
    } else if (this.mode == this.constModeRead) {
      // SZOA304Aリクエスト準備
      szoa304aCustomReq = {
        srnMethod: SgkbConstains.CODE.SRN_METHOD.OTHER, // 申込方法：'9'その他
        tksLinkEonflg: SgkbConstains.CODE.TAKUSOU_RENKEI_UMU_FLG.TRUE, // 託送連係有無フラグ：'1'(連係する)
        wtOrishiserviceproviderCode: fv.resaleBusCode, // ＷＴ卸利用事業者コード：非表示.ＷＴ卸利用事業者コード
        wtContractclassfyCode: fv.wtoroshiContractclassfyCode, // ＷＴ契約種別コード：契約共通情報.WT契約種別コード
        wtFutaicontractList: fv.wtoroshiGoodscode ? [ // ＷＴ付帯契約リスト（ＷＴ付帯契約コードが設定されている場合のみ設定する）
          {
            wtFutaicontractcode: fv.wtoroshiGoodscode, // ＷＴ付帯契約コード：契約共通情報.ＷＴ付帯契約コード
          }
        ] : null,
        wtCtrchgDivcd: <string>setWtCtrchgDivcd, // ＷＴ契約変更区分コード
        wtApplicationdateDivcd: fv.appliedAtTurnOn ? SgkbConstains.CODE.WT_ADOPT_DAY_DIV_CD.RETRO_CHANGE : SgkbConstains.CODE.WT_ADOPT_DAY_DIV_CD.NEXT_DAY, // ＷＴ適用日区分コード(開栓時適用にチェックがある場合'1'(遡及変更（開栓日orスイッチ日）)、それ以外'0'(次回検針日の翌日))
        wtCtrchgScddt: this.getFormattedDateYMD(fv.keiyakuHenkoYmd), // ＷＴ契約変更予定日付：適用年月日
        highefficiencyWaterheater: fv.highefficiencyWaterheater ? "1" : "0",  // 高効率給湯器：契約共通情報.高効率給湯器
        etcWaterheater: fv.etcWaterheater ? "1" : "0",  // その他給湯器：契約共通情報.その他給湯器
        kitchenequipment: fv.kitchenequipment ? "1" : "0",  // 厨房機器：契約共通情報.厨房機器
        yukadanbo: fv.yukadanbo ? "1" : "0",  // 床暖房：契約共通情報.床暖房
        bathroomheatingDryer: fv.bathroomheatingDryer ? "1" : "0",  // 浴室暖房乾燥機：契約共通情報.浴室暖房乾燥機
        etcHeatmachine: fv.etcHeatmachine ? "1" : "0",  // その他暖房機：契約共通情報.その他暖房機
        airconditioning: fv.airconditioning ? "1" : "0",  // 空調機器：契約共通情報.空調機器
        cogenerationDevice: fv.cogenerationDevice ? "1" : "0",  // コージェネ機器：契約共通情報.コージェネ機器

      };
      szoa304aRequest = {
        requestCommon: { // 共通情報
          businessDate: null,  // 業務日付
          startLine: 0,  // 取得開始行
          getNumber: 0,  // 取得件数
          dryRun: false,  // ドライラン
          businessReqId: null,  // 業務リクエストID
          funcLinkId: null,  // 機能連携ID
          requestCustomize: szoa304aCustomReq,
        },
        aceptInfo: { // 受付情報
          aceptNo: this.aceptNo,
          aceptRrkno: this.aceptRrkNo,
          updateSrno: this.updateSrno,
          updateDiv: SgkbConstains.CODE.UPDATE_DIV.CHANGE, // 更新区分：'2'(変更)
          visitNo: fv.visitNo,  // 内部お客さま番号：非表示.内部お客さま番号
          logicDeviceNo: fv.logicDeviceNo,  // 使用お客さま番号：非表示.使用お客さま番号
          firstSrvctrNo: fv.firstSrvctrNo,  // 契約お客さま番号：非表示.契約お客さま番号
          recptFixNo: fv.recptFixNo,  // 請求お客さま番号：非表示.請求お客さま番号
          simltnAceptNo: null,
          aceptClsfy: SgkbConstains.CODE.ACEPT_CLY_CD.GAS_CNTRCT_CHANGE,  // 受付種別コード：'040201'(ガス契約変更)
          aceptDate: this.timeApiService.getNowDateString(),  // 受付日付：業務日付
          aceptHms: this.timeApiService.getNowTimeString(),  // 受付時刻：システム時刻
          aceptSosikiCode: this.userOrganizationInfo.sosikiId,  // 受付担当組織番号：ログイン情報.組織番号
          aceptStaffNo: this.usrId,  // 受付担当社員番号：ログイン情報.社員番号
          cnscncYhiflg: SgkbConstains.CODE.TAKUSOU_CNTACT_TRANS_FLG.TRANS_NO_CONTACT,  // 託送連絡要否フラグ：'0'(託送連絡不要)
          extCnnctNo: fv.extCnnctNo,  // 外部接続番号：非表示.外部接続番号
        },
        ctrCommonInfo: { // 契約共通情報
          ctrendDateDiv: SgkbConstains.CODE.CNTRCT_ENDDAY_DIV.NO_TARGET,  // 契約終了日区分：'1'(指定なし)
          ctrchgDateDiv: fv.appliedAtTurnOn ? SgkbConstains.CODE.CNTRCT_STARTDAY_DIV.CNTRCT_START_DATE
            : SgkbConstains.CODE.CNTRCT_STARTDAY_DIV.REGLR_READMON_SPEC,  // 契約変更日区分：開栓時適用にチェックがある場合'3'(契約開始日指定)、それ以外'1'(定例検針月指定)
          ctrchgYm: fv.appliedAtTurnOn ? "" : this.getFormattedDateYM(fv.keiyakuHenkoYmd),  // 契約変更年月：契約共通情報.適用年月日（開栓時適用にチェックがない場合項目名の年月のみ設定）
          ctrChgDate: fv.appliedAtTurnOn ? this.getFormattedDateYMD(fv.keiyakuHenkoYmd) : "",  // 契約変更日付：契約共通情報.適用年月日（開栓時適用にチェックがある場合項目名）
          claimMntdiv: fv.claimMntdiv,  // 請求月度区分：非表示.請求月度区分
          rlysrnNo: fv.wtorishiserviceproviderAcceptancenumber,  // 中継店申込番号：契約共通情報.ＷＴ卸利用事業者受付番号
          rlystrFname: fv.rlystrFname,  // 中継店担当者名：非表示.中継店担当者名
          agnissVisitNo: fv.agnissVisitNo,  // 取次店発行お客さま番号：非表示.取次店発行お客さま番号
          prdCode: null,  // プロダクトコード：非表示.プロダクトコード
        },
        ftiGoodsInfo: null, // 付帯商品契約情報
        ctrTankaInfo: null, // 契約単価情報 
        gasConInfo: { // ガス契約情報
          acsptPointCode: this.dispAcsptPointCode,  // 受入地点コード
          cnsgmtCtrNo: "00000000000000000",  // 託送契約番号：「00000000000000000」（17桁）固定
          chargeCategCode: null,  // 託送供給契約約款区分コード：非表示.託送供給契約約款区分コード
        },
        gasConvalInfo: null, // ガス契約値情報
      }
      this.usedSgkb941dSzoa304aService.updateReception(szoa304aRequest)
        .subscribe(response => {
          if (response) {
            this.szoa304aResponse = response;
            // 受付情報．受付番号をHidden項目の受付番号に設定
            this.ctrCommonInfo.controls['aceptNo'].setValue(response.aceptInfo.aceptNo);
            // 登録完了画面遷移
            this.completeDataService.completeData = {
              title: 'WT契約変更登録完了',       // 画面タイトルを設定
              message: 'WT契約変更を登録しました', // 画面に表示するメッセージを設定
              next: '',
              koumokuList: [
                { label: "受付番号", val: this.ctrCommonInfo.getRawValue().aceptNo }
              ], // 画面に表示する情報
              queryParams: {
                "aceptNo": this.ctrCommonInfo.getRawValue().aceptNo,
              },
            }
            // 登録完了画面遷移
            this.router.navigate(['/sgkz003d']);
          }
        }, error => {
        });
    }
  }

  /**
   * キャンセルボタン押下時イベント
   * @memberof Sgkb941dWtContractChangeComponent
   */
  onCancel(): void {
    // 入力項目非活性
    this.ctrCommonInfo.disable();
    // 照会画面で保持していた画面表示項目の値を表示する
    this.dipsResaleBusAname = this.beforeFv.resaleBusAname;
    this.dispWtorishiserviceproviderAcceptancenumber = this.beforeFv.wtorishiserviceproviderAcceptancenumber;
    this.dispKeiyakuHenkoYmd = this.beforeFv.keiyakuHenkoYmd;
    this.dispWtoroshiContractclassfyCode = this.beforeFv.wtoroshiContractclassfyCode;
    this.dispWtoroshiGoodscode = this.beforeFv.wtoroshiGoodscode;
    this.dispHighefficiencyWaterheater = this.beforeFv.highefficiencyWaterheater;
    this.dispEtcWaterheater = this.beforeFv.etcWaterheater;
    this.dispKitchenequipment = this.beforeFv.kitchenequipment;
    this.dispYukadanbo = this.beforeFv.yukadanbo;
    this.dispBathroomheatingDryer = this.beforeFv.bathroomheatingDryer;
    this.dispEtcHeatmachine = this.beforeFv.etcHeatmachine;
    this.dispAirconditioning = this.beforeFv.airconditioning;
    this.dispCogenerationDevice = this.beforeFv.cogenerationDevice;
    this.dispResaleBusCode = this.beforeFv.resaleBusCode;
    this.dispVisitNo = this.beforeFv.visitNo;
    this.dispLogicDeviceNo = this.beforeFv.logicDeviceNo;
    this.dispFirstSrvctrNo = this.beforeFv.firstSrvctrNo;
    this.dispExtCnnctNo = this.beforeFv.extCnnctNo;
    this.dispClaimMntdiv = this.beforeFv.claimMntdiv;
    this.dispRlystrFname = this.beforeFv.rlystrFname;
    this.dispAgnissVisitNo = this.beforeFv.agnissVisitNo;
    this.dispAcsptPointCode = this.beforeFv.acsptPointCode;
    this.dispBefWtoroshiContractclassfyCode = this.beforeFv.befWtoroshiContractclassfyCode;
    this.dispBefWtoroshiGoodscode = this.beforeFv.befWtoroshiGoodscode;
    this.setDispItemValue();

    // 画面タイトル変更
    this.titleChange.emit('ＷＴ契約変更受付照会');
    // ボタン表示制御
    this.btnDispCtl(this.constModeRead);
  }

  /**
 * 閉じるボタン押下時イベント
 * @memberof Sgkb941dWtContractChangeComponent
 */
  onClose(): void {
    window.close();
  }

  /**
   * 編集ボタン押下時イベント
   * @memberof Sgkb941dWtContractChangeComponent
   */
  onEdit(): void {

    // 入力項目活性
    this.ctrCommonInfo.enable();
    // 画面タイトル変更
    this.titleChange.emit('ＷＴ契約変更受付編集');
    // 照会画面での画面項目を保持
    this.beforeFv = this.ctrCommonInfo.getRawValue();
    // ボタン表示制御
    this.btnDispCtl(this.constModeEdit);
  }

  /**
   * 取消ボタン押下時イベント
   * @memberof Sgkb941dWtContractChangeComponent
   */
  onDelete(): void {
    // 設定値算出
    const fv = this.ctrCommonInfo.getRawValue();

    const result = window.confirm('WT契約変更を取消しますか');

    if (result) {
      // 受付ステータスがエラーの場合
      if (this.aceptStsErrList.includes(this.aceptSts)) {
        // 受付ステータスを取消にする
        // SGKB983Aリクエスト準備
        const sgkb983aRequest: Sgkb983aRequest = {
          requestCommon: { // 共通情報
            businessDate: null,  // 業務日付
            startLine: 0,  // 取得開始行
            getNumber: 0,  // 取得件数
            dryRun: false,  // ドライラン
            businessReqId: null,  // 業務リクエストID
            funcLinkId: null,  // 機能連携ID
            requestCustomize: null
          },
          aceptInfo: { // 受付情報
            aceptNo: this.aceptNo,
            aceptRrkno: this.aceptRrkNo,
            updateSrno: this.updateSrno,
            aceptSts: '9000'
          }
        };

        this.usedSgkb941dSgkb983aService.registReception(sgkb983aRequest)
          .subscribe(response => {
            if (response) {
              this.sgkb983aResponse = response;
              // 受付情報．受付番号をHidden項目の受付番号に設定
              this.ctrCommonInfo.controls['aceptNo'].setValue(response.aceptInfo.aceptNo);
              // 登録完了画面遷移
              this.completeDataService.completeData = {
                title: 'WT契約変更取消完了',       // 画面タイトルを設定
                message: 'WT契約変更を取消しました', // 画面に表示するメッセージを設定
                next: '',
                koumokuList: [
                  { label: "受付番号", val: this.ctrCommonInfo.getRawValue().aceptNo }
                ], // 画面に表示する情報
                queryParams: {
                  "aceptNo": this.ctrCommonInfo.getRawValue().aceptNo,
                },
              }
              // 登録完了画面遷移
              this.router.navigate(['/sgkz003d']);
            }
          }, error => {
          });
      } else {
        // 更新区分を取消にする
        // SZOA304Aリクエスト準備
        const szoa304aCustomReq: Szoa304aCustomRequest = {
          tksLinkEonflg: SgkbConstains.CODE.TAKUSOU_RENKEI_UMU_FLG.TRUE, // 託送連係有無フラグ：'1'(連係する)
        };

        const szoa304aRequest: Szoa304aRequest = {
          requestCommon: { // 共通情報
            businessDate: null,  // 業務日付
            startLine: 0,  // 取得開始行
            getNumber: 0,  // 取得件数
            dryRun: false,  // ドライラン
            businessReqId: null,  // 業務リクエストID
            funcLinkId: null,  // 機能連携ID
            requestCustomize: szoa304aCustomReq,
          },
          aceptInfo: { // 受付情報
            aceptNo: this.aceptNo,
            aceptRrkno: this.aceptRrkNo,
            updateSrno: this.updateSrno,
            updateDiv: SgkbConstains.CODE.UPDATE_DIV.CANCEL, // 更新区分：'3'(取消)
            visitNo: null,  // 内部お客さま番号：null
            logicDeviceNo: null,  // 使用お客さま番号：null
            firstSrvctrNo: null,  // 契約お客さま番号：null
            recptFixNo: null,  // 請求お客さま番号：null
            simltnAceptNo: null, // 同時受付番号
            aceptClsfy: SgkbConstains.CODE.ACEPT_CLY_CD.GAS_CNTRCT_CHANGE,  // 受付種別コード：'040201'(ガス契約変更)
            aceptDate: this.timeApiService.getNowDateString(),  // 受付日付：業務日付
            aceptHms: this.timeApiService.getNowTimeString(),  // 受付時刻：システム時刻
            aceptSosikiCode: null,  // 受付担当組織番号：null
            aceptStaffNo: null,  // 受付担当社員番号：null
            cnscncYhiflg: null,  // 託送連絡要否フラグ
            extCnnctNo: null,  // 外部接続番号
          },
          ctrCommonInfo: null, // 契約共通情報
          ftiGoodsInfo: null, // 付帯商品契約情報
          ctrTankaInfo: null, // 契約単価情報 
          gasConInfo: null, // ガス契約情報
          gasConvalInfo: null, // ガス契約値情報
        }
        this.usedSgkb941dSzoa304aService.deleteReception(szoa304aRequest)
          .subscribe(response => {
            if (response) {
              this.szoa304aResponse = response;
              // 受付情報．受付番号をHidden項目の受付番号に設定
              this.ctrCommonInfo.controls['aceptNo'].setValue(response.aceptInfo.aceptNo);
              // 登録完了画面遷移
              this.completeDataService.completeData = {
                title: 'WT契約変更取消完了',       // 画面タイトルを設定
                message: 'WT契約変更を取消しました', // 画面に表示するメッセージを設定
                next: '',
                koumokuList: [
                  { label: "受付番号", val: this.ctrCommonInfo.getRawValue().aceptNo }
                ], // 画面に表示する情報
                queryParams: {
                  "aceptNo": this.ctrCommonInfo.getRawValue().aceptNo
                },
              }
              // 登録完了画面遷移
              this.router.navigate(['/sgkz003d']);
            }
          }, error => {
          });
      }
    } else {
      return;
    }
  }

  /**
   * WT契約変更区分判定
   * @memberof Sgkb941dWtContractChangeComponent
   */
  decisionWtCtrchgDiv(fv): string {
    // 変更前WT契約種別コードとWT契約種別コードが不一致の場合'1'(主契約の変更)
    if (fv.befWtoroshiContractclassfyCode != fv.wtoroshiContractclassfyCode) {
      return SgkbConstains.CODE.WT_CNTRCT_CHANGE_DIV_CD.MAINCHANGE;
    } else {
      // 変更前ＷＴ付帯契約コードが null、かつ、ＷＴ付帯契約コードがデータ有の場合 '8'(付帯契約の変更)
      if (fv.befWtoroshiGoodscode == null && fv.wtoroshiGoodscode != null && fv.wtoroshiGoodscode != '') {
        return SgkbConstains.CODE.WT_CNTRCT_CHANGE_DIV_CD.SUBCHANGE;
      }
      // 変更前ＷＴ付帯契約コードがデータ有、かつ、ＷＴ付帯契約コードが null の場合 '9'(付帯契約の解約)
      else if (fv.befWtoroshiGoodscode != null && fv.befWtoroshiGoodscode != '' && (fv.wtoroshiGoodscode == null || fv.wtoroshiGoodscode == '')) {
        return SgkbConstains.CODE.WT_CNTRCT_CHANGE_DIV_CD.SUBCANCEL;
      }
      // 変更前ＷＴ付帯契約コードとＷＴ付帯契約コードが不一致の場合 '8'(付帯契約の変更)
      else if (fv.befWtoroshiGoodscode != null && fv.wtoroshiGoodscode != null && fv.befWtoroshiGoodscode != fv.wtoroshiGoodscode) {
        return SgkbConstains.CODE.WT_CNTRCT_CHANGE_DIV_CD.SUBCHANGE;
      }
    }
  }

  /**
   * 日付String取得(YMD)
   * @memberof Sgkb941dWtContractChangeComponent
   */
  getFormattedDateYMD(val): string {
    const dateValue = val;
    if (dateValue) {
      const date = new Date(dateValue);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}${month}${day}`;
    }
    return '';
  }

  /**
   * 日付String取得(YM)
   * @memberof Sgkb941dWtContractChangeComponent
   */
  getFormattedDateYM(val): string {
    const dateValue = val;
    if (dateValue) {
      const date = new Date(dateValue);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      return `${year}${month}`;
    }
    return '';
  }
}
